import React, { useEffect } from "react";
import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Table } from "antd";
import UseApi from "../../../Reusable/CallApi/UseApi";
import { useSelector } from "react-redux";
// import UseApi from "../../../../hooks/UseApi";

const Styleddiv = styled.div`
  .first-people {
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    margin-bottom: 1rem;
  }

  .people-count-search {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 400;
  }

  .searchbar-style {
    color: #636980;
    border: 1px solid #e2e2e8;
    width: 210px;
    border-radius: 24px;
    font-size: 14px;
    font-weight: 400;
  }

  .table-row-white {
    background-color: #ffffff;
  }

  .table-row-gray {
    background-color: #f5f5f5;
  }

  .custom-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }

  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }

  .ant-table-tbody > tr > td {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
  }

  /* 15 columns - keep each header on one line and scroll sideways. */
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    white-space: nowrap;
  }
`;

const columns = [
  {
    title: "Employee ID",
    dataIndex: "employeeId",
    key: "employeeId",
  },
  {
    title: "Employee Name",
    dataIndex: "employeeName",
    key: "employeeName",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Enrolled in",
    dataIndex: "enrolledIn",
    key: "enrolledIn",
  },
  {
    title: "Completed",
    dataIndex: "completed",
    key: "completed",
  },
  {
    title: "In Progress",
    dataIndex: "inProgress",
    key: "inProgress",
  },
  {
    title: "Not Passed",
    dataIndex: "notPassed",
    key: "notPassed",
  },
  // Figma People Report: these follow Not Passed, table scrolls sideways.
  {
    title: "Not Started",
    dataIndex: "notStarted",
    key: "notStarted",
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
  },
  {
    title: "Grade Code",
    dataIndex: "gradeCode",
    key: "gradeCode",
  },
  {
    title: "Grade",
    dataIndex: "grade",
    key: "grade",
  },
  {
    title: "Competency",
    dataIndex: "competency",
    key: "competency",
  },
  {
    title: "Service Line",
    dataIndex: "serviceLine",
    key: "serviceLine",
  },
  {
    title: "Department",
    dataIndex: "department",
    key: "department",
  },
].map((column) => ({
  // Empty text fields show a dash instead of a blank cell; counts show 0.
  render: (value) => (value === null || value === undefined || value === "" ? "—" : value),
  ...column,
}));

function Reportsfile() {
  const { data, loading, request } = UseApi();
 const clientId = useSelector(
      (state) => state.authTracking.userInfo.clientId
    );
  const [searchTerm, setSearchTerm] = React.useState("");
  useEffect(() => {
    // UseApi's request() rethrows on failure - uncaught here, this was a
    // genuine unhandled promise rejection (CRA's dev error overlay
    // whenever this endpoint fails).
    request({ endPoint: `/report/getpeoplereport/${clientId}`, method: "get" }).catch(() => {});
  }, [clientId]);

  const allData = (data?.response || []).map((item, index) => ({
    key: index,
    ...item,
  }));

  const dataSource = allData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
      <Styleddiv>
        <div className="first-people">People Report</div>
        <br />
        <div className="people-count-search">
          <div>Total People: {allData.length}</div>
          <div>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined style={{ color: "#636980" }} />}
              className="searchbar-style"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <br />
        <div>
          <Table
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-white" : "table-row-gray"
            }
            className="custom-table"
            scroll={{ x: "max-content" }}
          />
        </div>
      </Styleddiv>
    </>
  );
}

export default Reportsfile;